import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ResetPasswordReducer from "./auth/resetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

import Dashboard from "./dashboard/reducer";

// Countries
import CountriesReducer from "./countries/reducer";

//  Sanctions List
import SanctionsListReducer from "./sanctions-list/reducer";

// Contracts
import ContractsReducer from "./contract/reducer";

// Contractors
import ContractorsReducer from "./contractor/reducer";

// Risk Ratings
import RiskRatingsReducer from "./risk-ratings/reducer";

// PVRs
import PVRsReducer from "./pvr/reducer";

// Organization Types
import OrganizationTypesReducer from "./organization-types/reducer";

// Search
import SearchReducer from "./search/reducer";

// Persons
import PersonsReducer from "./person/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  ResetPassword: ResetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: Dashboard,
  Countries: CountriesReducer,
  SanctionsList: SanctionsListReducer,
  Contracts: ContractsReducer,
  Contractors: ContractorsReducer,
  RiskRatings: RiskRatingsReducer,
  PVRs: PVRsReducer,
  OrganizationTypes: OrganizationTypesReducer,
  Search: SearchReducer,
  Persons: PersonsReducer,
});

export default rootReducer;
